import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const customizeShopApi = {
  postImportProductCustomize: (request) => {
    const { data } = request
    const url = `/api/cms/v1/${data.page_id}/shop-service/import-product-customize`
    return instance().post(url, data.body)
  }
}
export default customizeShopApi



// WEBPACK FOOTER //
// ./src/api/customize-shop.js